import { render, staticRenderFns } from "./ThirdMeasureTable.vue?vue&type=template&id=2d72c1cd&scoped=true&"
import script from "./ThirdMeasureTable.vue?vue&type=script&lang=js&"
export * from "./ThirdMeasureTable.vue?vue&type=script&lang=js&"
import style0 from "./ThirdMeasureTable.vue?vue&type=style&index=0&id=2d72c1cd&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72c1cd",
  null
  
)

export default component.exports